// ACTA_AGENT_ACTION_EXECUTOR_V2

export function executeImmediateAgentAction({
  action,
  navigate,
}) {
  if (
    action?.kind !==
      "navigation"
    || !action?.path
  ) {
    return false;
  }

  navigate?.(
    action.path
  );

  return true;
}
